import * as React from 'react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import S12nSubscriptionPropBulletPoints from 'bundles/enroll-modal/components/s12n-subscriptions/free-trialV2/S12nSubscriptionPropBulletPoints';
import S12nSubscriptionVPropCDPFreeTrial from 'bundles/enroll-modal/components/s12n-subscriptions/free-trialV2/S12nSubscriptionVPropCDPFreeTrial';
import type OnDemandSpecializationsV1 from 'bundles/naptimejs/resources/onDemandSpecializations.v1';
import { freeTrial } from 'bundles/payments-common/common/constants';
import { getShortS12nFreeTrialOverrideDays } from 'bundles/payments-common/utils/s12nFreeTrialEpicUtils';

import _t from 'i18n!nls/enroll';

import 'css!./__styles__/SubscriptionVPropFreeTrial';

type PropsFromCaller = {
  onSdp: boolean;
  s12n: OnDemandSpecializationsV1;
};

const S12nSubscriptionVPropFreeTrial = ({ onSdp, s12n }: PropsFromCaller) => {
  const numDays = getShortS12nFreeTrialOverrideDays(s12n.id) ?? freeTrial.numDays;

  return (
    <div className="rc-SubscriptionVPropFreeTrial">
      <h2 className="headline-5-text punch-line">
        <FormattedMessage message={_t('{numDays}-day Free Trial')} numDays={numDays} />
      </h2>
      {!onSdp && <S12nSubscriptionVPropCDPFreeTrial />}

      <S12nSubscriptionPropBulletPoints />
    </div>
  );
};

export default S12nSubscriptionVPropFreeTrial;
